import { ERROR_BASKET_ID, getBasketId } from './getBasket';

export const ADD_SERVICE_PATH =
  'checkout/baskets/[BASKET_ID]/products/[PRODUCT_ID]/services';
export const REMOVE_SERVICE_PATH =
  'checkout/baskets/[BASKET_ID]/products/[PRODUCT_ID]/services/[SERVICE_ID]';
export const ERROR_ADD_SERVICE_TO_BASKET =
  'There was an error adding the service to the basket.';
export const ERROR_ADD_SERVICE_TO_BASKET_INVALID_RESPONSE =
  'Invalid response received, when adding service to the basket.';

export const isResponseObjectValid = (response) => !!(
  response &&
  response.payload &&
  response.payload.id &&
  response.payload.products &&
  response.payload.products.length
);

export const isValidAddToBasketResponse = (basketId, productId, serviceId, response) => {
  let isValid = false;
  if (isResponseObjectValid(response) && response.payload.id === basketId) {
    const basketProducts = response.payload.products;
    isValid = basketProducts
      .filter((product) => product.id === productId &&
        product.services
          .filter((service) => service.id === parseInt(serviceId, 10))
          .length > 0)
      .length > 0;
  }
  return isValid;
};

export const isValidRemoveFromBasketResponse = (basketId, productId, serviceId, response) => {
  let isValid = false;
  if (isResponseObjectValid(response) && response.payload.id === basketId) {
    const basketProducts = response.payload.products;
    isValid = basketProducts
      .filter((product) => product.id !== productId ||
        product.services
          .filter((service) => service.id === parseInt(serviceId, 10))
          .length === 0)
      .length === basketProducts.length;
  }
  return isValid;
};

export const addServiceToBasket = async (storeUrl, productId, serviceId) => {
  const basketId = await getBasketId(storeUrl);
  if (!basketId) {
    throw new Error(ERROR_BASKET_ID);
  }
  const addServicePath = ADD_SERVICE_PATH
    .replace('[BASKET_ID]', basketId)
    .replace('[PRODUCT_ID]', productId);
  const addToBasketUrl = `${storeUrl}/${addServicePath}`;
  const params = { serviceId };
  let addToBasketResponse;
  try {
    addToBasketResponse = await fetch(addToBasketUrl, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json'
      }
    });
  } catch (e) {
    throw new Error(ERROR_ADD_SERVICE_TO_BASKET);
  }
  const addToBasketResponseJSON = await addToBasketResponse.json();
  if (isValidAddToBasketResponse(basketId, productId, serviceId, addToBasketResponseJSON)) {
    return { basketId };
  }
  throw new Error(ERROR_ADD_SERVICE_TO_BASKET_INVALID_RESPONSE);
};

export const removeServiceFromBasket = async (storeUrl, basketId, productId, serviceId) => {
  const removeServicePath = REMOVE_SERVICE_PATH
    .replace('[BASKET_ID]', basketId)
    .replace('[PRODUCT_ID]', productId)
    .replace('[SERVICE_ID]', serviceId);
  const url = `${storeUrl}/${removeServicePath}`;
  let response;
  try {
    response = await fetch(url, {
      method: 'DELETE',
      credentials: 'include'
    });
  } catch (e) {
    throw new Error(
      'There was an error removing the service from basket.'
    );
  }

  const responseJSON = await response.json();
  if (isValidRemoveFromBasketResponse(basketId, productId, serviceId, responseJSON)) {
    return responseJSON;
  }

  throw new Error(
    'Invalid response received, when removing service from basket.'
  );
};
